export const lensAddresses = {
  accountLens: "0x8fE9A01F035B2C6891fD4F70f489A96dc746a08C",
  eulerEarnVaultLens: "0x5e89dd31Bca9Fe57E26a5E8e375EEaeb9Eb2a5B6",
  irmLens: "0x4365E4dE90d454EE1D2F6e3D09e4e30B1Ab93c44",
  oracleLens: "0x336b1F8969557E69536E69055B4ef0fB8762b135",
  utilsLens: "0x681eD47409AF872B7EE81885cDb6A6cF3b2B9242",
  vaultLens: "0x94Dd6A076838D6Fc5031e32138b95d810793DB1c",
} as const
